<template>
   <transition name="modal-fade">
      <form class="search-area filterForm" @submit.prevent="applyFilter">
         <div class="mt-5" v-if="$props.where === 'intro'">
            <div >
               <div class="input-group-append ">
                  <label for="field-area-cerca" class="sr-only d-none active" style="transition: none 0s ease 0s;">Cerca</label>

                  <input type="search" id="field-cerca" placeholder="Cerca" class="form-control" v-model="query" debounce="500" />

                  <div class="input-group-append reset">
                     <button class="btn no-radius btn-minimal-padding" type="reset" @click="clearSearchArea" name="resetRicerca">
                        <svg class="icon icon-sm"><use xlink:href="@/assets/img/sprite.svg#it-close-big"></use></svg>
                     </button>
                  </div>
                     <button class="btn btn-primary btn-minimal-padding" @click="applyFilter" name="applicaFiltriRicerca">
                        <svg class="icon icon-sm"><use xlink:href="@/assets/img/sprite.svg#it-search"></use></svg>
                     </button>
               </div>
            </div>
            <div class="mt-5">
               <button type="button" class="btn btn-default btn-sm" @click="toggleModal" name="aggiungiFiltroRicerca">Aggiungi Filtro</button>
               <button type="button" class="btn btn-secondary btn-sm ml-2" v-if="argomento.length > 0 || tipologia.length > 0 || areaSpecializzazione.length > 0"  @click="removeFilters">Rimuovi Filtro</button>
            </div>
            <div class="mt-2">
               <b-form-checkbox-group id="checkbox-argomenti" v-model="argomento" :options="this.$root.argomenti" text-field="key" value-field="key" size="sm" buttons plain button-variant="chip"></b-form-checkbox-group>
               <b-form-checkbox-group id="checkbox-tipologie" v-model="tipologia" :options="tipologie" name="tipologia" text-field="text" value-field="value" buttons plain button-variant="chip"></b-form-checkbox-group>
               <b-form-checkbox-group id="checkbox-areaSpecializzazione" v-model="areaSpecializzazione" :options="this.$root.areeSpeciali" name="areaSpecializzazione" text-field="titolo" value-field="id" buttons plain button-variant="chip"></b-form-checkbox-group>
               <b-form-checkbox class="sm" checked="1" name="check-button" v-model="period.active" button button-variant="chip"><span>periodo: {{period.dal}}-{{period.al}}</span></b-form-checkbox>
            </div>
         </div>          

         <div class="d-none d-lg-flex" v-if="$props.where === 'header'">
            <div class="it-search-wrapper" @click="toggleModal">
               <span class="d-none d-md-block">Cerca</span>
               <div class="search-link rounded-icon">
                  <a class="search-link rounded-icon" v-b-modal.modal-1 >
                     <svg class="icon">
                        <use xlink:href="@/assets/img/sprite.svg#it-search"></use>
                     </svg>
                  </a>
               </div> 
            </div>
         </div>
         <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': active}"
            tabindex="-1"
            role="dialog"
            >
            <div class="modal-dialog modal-xl m-1 m-md-auto" role="document">
              <div class="modal-content p-0 p-md-4">
                  <div class="modal-header">
                     <div class="w-100 d-block clearfix" id="formAreaSearch">
                       
                        <h4 class="h2" v-if="$props.where !== 'header'">Cerca {{$props.title}}</h4>
                        <h4 class="h2" v-if="$props.where == 'header'">Cerca</h4>

                        <div class="input-group">
                           <label for="field-cerca" class="sr-only d-none active" style="transition: none 0s ease 0s;">Cerca</label>
                              <input type="search" name="q" id="field-cerca" placeholder="Cerca" class="form-control" v-model="query"/>

                              <div class="input-group-append reset">
                                 <button class="btn no-radius btn-minimal-padding" type="reset" @click="clearSearchArea" name="resetRicerca">
                                    <svg class="icon icon-sm"><use xlink:href="@/assets/img/sprite.svg#it-close-big"></use></svg>
                                 </button>
                              </div>
                           <button class="btn btn-primary btn-minimal-padding" type="submit" @click="applyFilter" name="applicaRicerca"><svg class="icon icon-sm"><use xlink:href="@/assets/img/sprite.svg#it-search"></use></svg></button>
                        </div>
                        
                     </div>

                     <div class="d-block clearfix">
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close" @click="toggleModal" name="closeModalRicerca">
                           <svg class="icon icon-lg"><use xlink:href="@/assets/img/sprite.svg#it-close"></use></svg>
                        </button>     
                     </div>                                        
                  </div>

                  <div class="modal-body p-0 p-md-4 mt-4" id="filterTabs" v-if="$props.where !== 'header'">
                     <h3 class="modal-title primary-color">Filtri</h3>
                     <b-tabs content-class="tab-pane p-4" nav-wrapper-class="nav-link h5 pb-0 text-uppercase text-center" align="center" justified>
                        <b-tab class="w-100" title="ARGOMENTI" active>
                           <b-form-checkbox-group
                              id="checkbox-argomenti"
                              v-model="argomento"
                              :options="this.$root.argomenti"
                              class="customCheck1"
                              text-field="key"                              
                              value-field="key" 
                              debounce="500"       
                              plain
                              stacked  
                           ></b-form-checkbox-group>
                        </b-tab>

                        <b-tab title="TIPI CONTENUTO" v-if="this.$props.full">
                           <b-form-checkbox-group
                              id="checkbox-group-2"
                              v-model="tipologia"
                              :options="tipologie"
                              name="tipologia"
                              text-field="text"                              
                              value-field="value"
                              plain
                              stacked
                           ></b-form-checkbox-group>
                        </b-tab>

                        <b-tab title="AREE SPECIALIZZAZIONE" v-if="this.$props.full">
                           <b-form-checkbox-group
                              id="checkbox-aree"
                              v-model="areaSpecializzazione"
                              :options="this.$root.areeSpeciali"
                              name="areaSpecializzazione"
                              text-field="titolo"                              
                              value-field="id"
                              plain
                              stacked
                           ></b-form-checkbox-group>
                        </b-tab>

                        <b-tab  title="PERIODO" v-if="!this.$props.full">
                           <div class="row">
                              <div class="form-check col-12 col-md-4">
                                 <div class="toggles">
                                    <label for="toggleEsempio1a" class="text-uppercase">
                                    PERIODO
                                    <!--input type="checkbox" id="toggleEsempio1a" data-toggle="collapse" data-target="#dateRange" class="" aria-expanded="true"><span class="lever"></span--></label>
                                 </div>
                                 <p>
                                    Se non indichi un  “Periodo” di riferimento saranno mostrati tutti i contenuti dal più recente al meno recente partendo dalla data odierna
                                 </p>
                              </div>
                              <div class="col-12 col-md-8 collapse show" id="dateRange" style="">
                                 <div class="row">
                                    <div class="col-12 col-md-6">
                                       <div class="it-datepicker-wrapper mt-5">
                                          <div class="form-group">
                                             <label for="dal" class="pl-0 active" style="transition: none 0s ease 0s;">DAL</label>     
                                             <date-picker 
                                                v-model="period.dal"
                                                placeholder="gg/mm/aaaa"
                                                :name="`date1`"
                                                input-class="form-control it-date-datepicker"
                                                :input-attr="({ name: 'dal', id: 'dal'})"
                                                :disabled-date="notAfterAl"
                                                format="DD/MM/YYYY"
                                                valueType="DD/MM/YYYY"
                                                >                                                
                                             </date-picker>
                                          </div>
                                       </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                       <div class="it-datepicker-wrapper mt-5">
                                          <div class="form-group">               
                                             <label for="al" class="pl-0 active" style="transition: none 0s ease 0s;">AL</label>
                                             <date-picker 
                                                v-model="period.al" 
                                                placeholder="gg/mm/aaaa" 
                                                :input-attr="({ name: 'al', id: 'al'})"
                                                input-class="form-control it-date-datepicker" 
                                                :disabled-date="notBeforeDal"                                                
                                                format="DD/MM/YYYY"
                                                valueType="DD/MM/YYYY"
                                                >
                                             </date-picker>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </b-tab>
                     </b-tabs>
                     <div class="float-right input-group-inline ml-auto">
                        <button type="button" class="btn btn-primary ml-auto" @click="applyFilter"  name="applicaFiltriRicerca">
                           Applica i filtri
                        </button>
                     </div>                     
                  </div>

               </div>
            </div>
         </div>
         <div v-if="active" class="modal-backdrop fade show"></div>
      </form>
   </transition>
</template>
<script>
   import DatePicker from 'vue2-datepicker';
   import 'vue2-datepicker/index.css';
   import 'vue2-datepicker/locale/it';

   export default {
      name: "searchArea",

      components: { 
         DatePicker,
      },  

      props: {
         where: {
            type: String,
            description: "Dove di trova la ricerca e il comportamento"
         },
         title:{
            type: String,
            description: "titolo della ricerca"
         },
         full:{
            type: Boolean,
            default: false            
         },             
         who: { 
            type: String,
         },
         inactive: {
            type: Boolean,
         },         
         init: {
            type: Boolean,
            default: true
         }
      },

      data() {
         return {
            active: false,
            show: false,
            period: {
               active: false,
               dal: '',
               al: ''
            },
            query: (this.$attrs.query !== undefined ? this.$attrs.query : ''),
            areaSpecializzazione: [],
            areeSpecializzazione: [],            
            argomento: [],
            argomenti: [],
            tipologia: [],
            tipologie: [
               { text: 'Articolo', value: 'ArticoloPublished' },
               { text: 'Evento', value: 'EventoPublished' },
               { text: 'Notizia', value: 'NotiziaPublished' },
               { text: 'Partecipanti', value: 'PartecipantiPublished' },               
            ],            
         };
      },
      
      methods: {
         applyFilter() {            
            if(this.active){               
               this.toggleModal();
            }
            if(this.argomento.length > 0 || this.period){
               this.emitFilters();
            }
         },

         emitFilters: function(){
            this.$emit('setSearched', true);
            this.$emit('setArgSelected', this.argomento);
            this.$emit('setAreaSelected', this.areaSpecializzazione);
            this.$emit('setTipoSelected', this.tipologia);
            this.$emit('queryWatcher', this.query);  
         },

         clearSearchArea(){
            this.query = '';
            this.argomento = [];
            this.$emit('clearSearch', 1);
         },

         toggleModal() {
            const body = document.querySelector("body");
            this.active = !this.active;
            this.active
              ? body.classList.add("modal-open")
              : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
         },

         notAfterAl(date) {
            if(this.period.al !== null){
               const dalDate = this.period.al.split('/');
               const d = new Date();
               d.setDate(dalDate[0]);
               d.setMonth(dalDate[1]-1);
               d.setFullYear(dalDate[2]);
               return date > new Date(d);
            }
            else{
               return date > new Date(new Date().setHours(0, 0, 0, 0));
            }
         },  

         notBeforeDal(date) {
            if(this.period.dal !== null){
               const dalDate = this.period.dal.split('/');
               const d = new Date();
               d.setDate(dalDate[0]);
               d.setMonth(dalDate[1]-1);
               d.setFullYear(dalDate[2]);
               return date < new Date(d);
            }
            else{
               return date > new Date(new Date().setHours(0, 0, 0, 0));
            }
         },
         removeFilters:function(){
            this.tipologia = this.areaSpecializzazione = this.argomento = [];
         },         
      },

      mounted(){
         if(this.$route.query.q !== undefined || ( this.$route.params.keywords !== undefined && this.$route.params.keywords != '')){
            this.query = this.$route.params.keywords != '' ? this.$route.params.keywords : this.$route.query.q;
         }
         if(this.$route.params.argomenti !== undefined && this.$route.params.argomenti.length > 0){
            this.argomento = this.$route.params.argomenti;
         }
         if(this.$route.params.areeSpecializzazione !== undefined && this.$route.params.areeSpecializzazione.length > 0){
            this.areaSpecializzazione = this.$route.params.areeSpecializzazione;
         }
         if(this.$route.params.tipologie !== undefined && this.$route.params.tipologie.length > 0){
            this.tipologia = this.$route.params.tipologie;
         } 
      },

      watch: {
         // whenever question changes, this function will run
         query: function () {
            this.$emit('queryWatcher', this.query);
         },

         argomento: function(){
            this.emitFilters();
         },

         tipologia: function(){
            this.emitFilters();
         },

         areaSpecializzazione: function(){
            this.emitFilters();
         },

         'period.dal': function(){
            if(this.period.dal != null && this.period.al != null){
               this.period.active = true;
            }else{
               this.period.active = false;
            }
            this.$emit('setPeriod', this.period);
         },

         'period.al': function(){
            if(this.period.dal != null && this.period.al != null){
               this.period.active = true;
            }else{
               this.period.active = false;
            }
            this.$emit('setPeriod', this.period);
         },
         
         'period.active': function(){
            if(!this.period.active){
               this.period.dal = this.period.al = null;
            }
            this.$emit('setPeriod', this.period);
         }
      },      
   };

</script>
<style>
#filterTabs .nav-item .nav-link{ width:100%; }
input[type="search"]:placeholder-shown + .input-group-append > .reset {
    display: none;
}
.close{position:absolute;right: 40px;top: 30px;}
.input-group-append .btn[type="reset"]{border-bottom: 1px solid #737272}
.btn-group{ display:inline-block; }
.btn.btn-chip:hover:not(.chip-disabled) {
   background: #F2F2F2;
   border-color: #005c99;
   transition: background-color 0.1s;
   text-decoration: none;
   font-weight: 600;
}

.btn.btn-chip {
   margin-bottom: 6px;
   display: none;
   justify-content: space-evenly;
   align-items: center;
   background: #fff;
   border: 1px solid #005c99;
   border-radius: 12px !important;
   color: #000;
   height: 24px;
   min-width: 100px;
   padding: 4px 32px 4px 32px !important;
   transition: all 0.05s;
   margin-right: 4px;
   font-size: 0.77778rem;
   text-decoration: none;
   font-weight: 600;
   line-height: 1.0rem;
   height: min-content;
   white-space: nowrap;
   box-shadow: unset !important;
}
    
.btn.btn-chip > span {
   font-size: 0.778rem;
   height: 16px;
   font-weight: 600;
   color: #000 !important;
   margin-bottom: 0;
   transform: translateY(-2px);
   transition: color 0.05s;
   text-decoration: none;    
   margin-left: -6px;
 }

.btn.btn-chip > span:after{
   content: "x";
   position: relative;
   right: -6px;
   top: -1px;
   font-weight: normal;
   color: #666;
   transform:scale(1.25, 1.1);
   cursor: pointer;
 }
.btn.btn-chip.active {
   display: inline-block;
}
</style>
